/**
 * @override Header 2.0: GetFullMenuItemById uses overlay FullMenuItemFragment.
 * Generated FullMenuItem spreads LinkFragment (unbounded menuImageGallery) → complexity 400.
 */

import gql from 'graphql-tag';

import {FullMenuItemFragment} from '@amblique/king-living/app/contentful/fragments/menu-item/full-menu-item.fragment';

export {
  getBaseMenuItemById,
  getMenuItemById,
  getBaseMenuItems,
  getMenuItems,
  getFullMenuItems,
} from '@amblique/contentful/app/contentful/queries/menu-item.queries';

export const getFullMenuItemById = gql`
  ${FullMenuItemFragment}

  query GetFullMenuItemById($id: String!, $locale: String!, $preview: Boolean) {
    menuItem(id: $id, locale: $locale, preview: $preview) {
      ...FullMenuItemFragment
    }
  }
`;
